import { BackButton, Button, LoadingButton } from "components/form";
import React, { act, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CiShare1 } from "react-icons/ci";
import "./MySurveys.scss";
import { csvIcon, groupIcon, questionIcon, watchIcon } from "assets/icons";
import { IoIosArrowForward } from "react-icons/io";
import { IoShareSocialOutline } from "react-icons/io5";
import CustomModal from "components/modals/CustomModal";
import { surveyPlaceholderImg, userProfilePlaceholder } from "assets/images";
import { handleDecryptionParams } from "utils/dataCipherHelper";
import {
  capitalizeFirstLetter,
  charLimit,
  getValueOrFallback,
  isArrayEmpty,
  isObjectEmpty,
  transformArrayToObject,
} from "utils/commonHelper";
import {
  exportFeedbackListAPI,
  surveyDetailsApi,
  surveyParticipantListApi,
} from "services/survey";
import { getFromLocal } from "config/axiosInstance";
import {
  ANNUAL_INCOMES,
  EDUCATION_LEVELS,
  LIVING_SITUATIONS,
  MARITAL_STATUSES,
  USER_EMPLOYEMENT,
  USER_GENDER,
} from "constant/staticData";
import {
  formattedDateDDMMMMYYYY,
  formattedDateDDMMMYYYY,
} from "utils/dateHelper";
import useShimmer from "hooks/useShrimmer";
import FeedbackSurveyDetail from "shrimmer/Survey/FeedbackSurveyDetail";
import FeedbackSideSurveyDetail from "shrimmer/Survey/FeedbackSideSurveyDetail";
import FeedbackUpperSurveyDetail from "shrimmer/Survey/FeedbackUpperSurveyDetail";
import FeedbackSurveyParticipnat from "shrimmer/Survey/FeedbackSurveyParticipnat";
import AcceptAllSurvey from "./AcceptAllSurvey";
import ExtendSurveyDate from "./ExtendSurveyDate";
import { toastMessage } from "utils/toastMessageHelper";
import SelectedParticipantFeedback from "./SelectedParticipantFeedback";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

// import { userProfilePlaceholder } from "assets/images";

const FeedbackSurvey = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const surveyDemographicValue = [
    { key: "gender", label: "Gender", data: USER_GENDER },
    // { key: "age", label: "Age", data: USER_AGE },
    { key: "annualIncome", label: "Annual Income", data: ANNUAL_INCOMES },
    { key: "educationLevel", label: "Education Level", data: EDUCATION_LEVELS },
    { key: "martialStatus", label: "Marital Status", data: MARITAL_STATUSES },
    {
      key: "employementInfo",
      label: "Employment Status",
      data: USER_EMPLOYEMENT,
    },
    {
      key: "livingSituation",
      label: "Living Situation",
      data: LIVING_SITUATIONS,
    },
  ];

  // Set all value
  const [searchParams, setSearchParams] = useSearchParams();
  const [feedbackSurvey, setFeedbackSurvey] = useState(false);
  const [selectedSurveyDetail, setSelectedSurveyDetail] = useState({});
  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams,
    "Cannot fetch the information"
  );
  const [activePage, setActivePage] = useState(1);

  const selectedSurveyId = getParamsData?.surveySlug || "";
  const [surveyParticipantList, setSurveyParticipantList] = useState([]);
  const [totalSurveyParticipant, setTotalSurveyParticipant] = useState(0);
  const [acceptAllSurveyModel, setAcceptAllSurveyModel] = useState(false);
  const [extendSurveyDateModel, setExtendSurveyDateModel] = useState(false);
  const [selectedParticipantDetail, setSelectedParticipantDetail] = useState(
    {}
  );
  const [language, setLanguage] = useState("en");

  // for feedback model

  const [feedbackStatusLoader, setFeedbackStatusLoader] = useState(false);

  // Hook
  const [showSurveyDetailShimmer, setShowSurveyDetailShimmer] =
    useShimmer(FeedbackSurveyDetail);
  const [showSideSurveyDetailShimmer, setShowSideSurveyDetailShimmer] =
    useShimmer(FeedbackSideSurveyDetail);
  const [showUpperSurveyDetailShimmer, setShowUpperSurveyDetailShimmer] =
    useShimmer(FeedbackUpperSurveyDetail);
  const [showSurveyParticipantList, setShowSurveyParticipantList] = useShimmer(
    FeedbackSurveyParticipnat
  );

  // function handler

  // Fetching Selected Survey Details API
  const fetchSelectedSurveyDetail = async (surveyId) => {
    if (surveyId) {
      try {
        setShowSurveyDetailShimmer(true);
        setShowSideSurveyDetailShimmer(true);
        setShowUpperSurveyDetailShimmer(true);
        const reqData = { surveyId: surveyId, token: getFromLocal() };
        const responseData = await surveyDetailsApi(reqData);
        const {
          data: { surveyDetail = {} },
          status,
        } = responseData;
        if (status === 200) {
          setSelectedSurveyDetail(
            isObjectEmpty(surveyDetail) ? {} : surveyDetail
          );
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setShowSurveyDetailShimmer(false);
        setShowSideSurveyDetailShimmer(false);
        setShowUpperSurveyDetailShimmer(false);
      }
    }
  };

  // Fetch all Participant list of selected user
  const fetchParticipantListHandler = async (surveyId) => {
    try {
      setShowSurveyParticipantList(true);
      const reqData = {
        surveyId: surveyId,
        token: getFromLocal(),
        limit: 10,
        page: activePage,
      };
      const responseData = await surveyParticipantListApi(reqData);
      const {
        data: { participantList = [], total = 0 },
        status,
      } = responseData;
      if (status === 200) {
        // setSurveyParticipantList(participantList);
        if (Number(activePage) === 1) {
          setSurveyParticipantList(participantList);
          // toastMessage(message, "success", "SurveyList");
        } else {
          setSurveyParticipantList((prevParticipantList) => [
            ...prevParticipantList,
            ...participantList,
          ]);
        }
        setTotalSurveyParticipant(total);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowSurveyParticipantList(false);
    }
  };

  // handle file download
  // const handleFileDownloader = () => {
  //   const fileUrl = `${process.env.REACT_APP_API_URL}/survey/export-participant-feedback-list`;
  //   const fileName = `user-list-${Date.now()}`;
  //   downloadFile(fileUrl, fileName);
  // };

  // Export Feedback list handler
  const exportFeedbackListHandler = async () => {
    try {
      const reqData = {
        responseType: "blob",
        token: getFromLocal(),
        surveyId: selectedSurveyId,
      };

      const response = await exportFeedbackListAPI(reqData);
      const { data, message, status } = response;
      if (status === 200) {
        toastMessage("success", message, "exportFileName");

        // Create a link element to download the file
        const link = document.createElement("a");
        link.href = data?.fileLink;

        // Set the download attribute with a filename
        const filename = "FeedbackList.xlsx";
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log("EXPORT FEEDBACK RESPONSE", data?.fileLink);
      }
    } catch (err) {
      console.error(err);
      // toast.error("Error occurred while downloading the file.");
    }
  };

  // Close Model Handler

  const closeModel = () => {
    setAcceptAllSurveyModel(false);
    setExtendSurveyDateModel(false);
    setFeedbackSurvey(false);
    setSelectedParticipantDetail("");
  };

  // Accept all survey
  const acceptAllSurveyHandler = (event) => {
    event.preventDefault();
    setAcceptAllSurveyModel(true);
  };

  const selectedViewSurveyHandler = (participant) => {
    setFeedbackSurvey(true);
    setSelectedParticipantDetail(participant);
  };

  useEffect(() => {
    fetchSelectedSurveyDetail(selectedSurveyId);
  }, []);

  useEffect(() => {
    fetchParticipantListHandler(selectedSurveyId);
  }, [activePage]);

  useEffect(() => {
    if (!getParamsData) {
      navigate("/dashboard/surveys");
    }
  }, [getParamsData, navigate]);

  const surveyListStatusHandler = (callType, status) => {
    if (callType === "title") {
      if (status === "accepted") {
        return t(`PARTICIPANT_FEEDBACK.Accepted`);
      }

      if (status === "rejected") {
        return t(`PARTICIPANT_FEEDBACK.Rejected`);
      }

      if (status === "pending") {
        return t(`PARTICIPANT_FEEDBACK.UnderReview`);
      }
    } else {
      return `tag ${status}`;
    }
  };

  return (
    <>
      <div className="survey_feedback">
        <BackButton text={t("PARTICIPANT_FEEDBACK.backResult")} />
        {showUpperSurveyDetailShimmer || (
          <h3 className="dashboard_title">
            {charLimit(getValueOrFallback(selectedSurveyDetail?.title), 50)}{" "}
            <span>
              {getValueOrFallback(selectedSurveyDetail?.surveyReferenceNumber)}
            </span>
          </h3>
        )}

        <div className="survey_feedback_content">
          <div className="participants_responses">
            {showSurveyDetailShimmer || (
              <div className="_card">
                <div className="has_child">
                  <h5>{t("PARTICIPANT_FEEDBACK.link")}</h5>
                  {/* <Link to="#" onClick={(e) => e.preventDefault()}>
                    View Analysis
                  </Link> */}
                </div>
                <p>
                  <Link
                    to="#"
                    className="url_link"
                    onClick={(e) => e.preventDefault()}
                  >
                    https://Example.com <CiShare1 />
                  </Link>
                </p>
                <h5>{t("PARTICIPANT_FEEDBACK.description")}</h5>
                <p>{getValueOrFallback(selectedSurveyDetail?.description)}</p>
              </div>
            )}
            {/* {showSurveyParticipantList || ( */}
            <div className="_card">
              <div className="has_child">
                <h5>
                  {t("PARTICIPANT_FEEDBACK.participantResponse")}
                  <span>({totalSurveyParticipant ?? 0})</span>
                </h5>
                <div className="download_button_wrap">
                  <LoadingButton
                    onClick={exportFeedbackListHandler}
                    // loading={isLoading}
                    disabled={
                      !surveyParticipantList ||
                      surveyParticipantList?.length === 0
                    }
                  >
                    <img src={csvIcon} alt="" />{" "}
                    {t("PARTICIPANT_FEEDBACK.exportCsv")}
                  </LoadingButton>
                  <button
                    className="acceptAllSurvey"
                    onClick={(e) => acceptAllSurveyHandler(e)}
                    disabled={
                      !surveyParticipantList ||
                      surveyParticipantList?.length === 0
                    }
                  >
                    {t("PARTICIPANT_FEEDBACK.acceptAllSurvey")}
                  </button>
                </div>
              </div>
              <ul>
                {showSurveyParticipantList || (
                  <InfiniteScroll
                    // height={90}
                    dataLength={surveyParticipantList?.length || 0}
                    next={() => setActivePage((prev) => prev + 1)}
                    hasMore={
                      surveyParticipantList?.length < totalSurveyParticipant
                    }
                    loader={showSurveyParticipantList}
                    // inverse={true}
                    endMessage={
                      Number(activePage) > 1 && (
                        <p
                          style={{ textAlign: "center", cursor: "pointer" }}
                          // onClick={scrollToTop}
                        >
                          <b>{t("PARTICIPANT_FEEDBACK.noParticipantList")}</b>
                        </p>
                      )
                    }
                  >
                    {!isArrayEmpty(surveyParticipantList) &&
                    surveyParticipantList?.length ? (
                      surveyParticipantList?.map(
                        ({ status, createdAt, participant }, index) => (
                          <li key={`survey-participant-list-${index}`}>
                            <p>
                              <div className="profile">
                                <img
                                  src={userProfilePlaceholder}
                                  alt="user profile"
                                />
                                <b>{getValueOrFallback(participant?.userId)}</b>
                              </div>
                              <span>{`${formattedDateDDMMMYYYY(
                                createdAt || ""
                              )} . ${
                                participant?.ageCategory || ""
                              } ${getValueOrFallback(
                                capitalizeFirstLetter(participant?.gender)
                              )}`}</span>{" "}
                            </p>
                            <p>
                              <button
                                type="button"
                                className={surveyListStatusHandler(
                                  "class",
                                  status
                                )}
                              >
                                {surveyListStatusHandler("title", status)}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  selectedViewSurveyHandler({
                                    ...participant,
                                    createdAt: createdAt,
                                  })
                                }
                              >
                                {t("PARTICIPANT_FEEDBACK.viewSurvey")}
                                <IoIosArrowForward />
                              </button>
                            </p>
                          </li>
                        )
                      )
                    ) : (
                      <NotFoundPlaceHolder
                        title={t(
                          "PARTICIPANT_FEEDBACK.participantFeedbackNotFound"
                        )}
                        placeHolderImage={surveyPlaceholderImg}
                        className="participantFeedbackList"
                      />
                    )}
                  </InfiniteScroll>
                )}
              </ul>
            </div>
            {/* )} */}
          </div>
          {showSideSurveyDetailShimmer || (
            <div className="participants_summery">
              <div className="_card">
                <h5>{t("PARTICIPANT_FEEDBACK.summary")}</h5>
                <ul className="has_image_icon">
                  <li>
                    <img src={questionIcon} alt="" />{" "}
                    <span>
                      {selectedSurveyDetail?.totalQuestionCount ?? 0}{" "}
                      {t("PARTICIPANT_FEEDBACK.totaQuestion")}
                    </span>
                  </li>
                  <li>
                    <img src={groupIcon} alt="" />{" "}
                    <span>
                      {`${selectedSurveyDetail?.totalParticipantCount ?? 0} 
                    ${t("PARTICIPANT_FEEDBACK.participant")}`}
                    </span>
                  </li>
                  <li>
                    <img src={watchIcon} alt="" />{" "}
                    <span>
                      {t("PARTICIPANT_FEEDBACK.creationDate")}
                      {selectedSurveyDetail?.createdAt
                        ? formattedDateDDMMMMYYYY(
                            selectedSurveyDetail?.createdAt
                          )
                        : "---"}
                    </span>
                  </li>
                  <li>
                    <img src={watchIcon} alt="" />{" "}
                    <span>
                      {t("PARTICIPANT_FEEDBACK.expiryDate")}
                      {selectedSurveyDetail?.expiryDate
                        ? formattedDateDDMMMMYYYY(
                            selectedSurveyDetail?.expiryDate
                          )
                        : "---"}
                    </span>
                  </li>
                </ul>

                <h5>{t("PARTICIPANT_FEEDBACK.demographic")}</h5>

                <ul>
                  {surveyDemographicValue?.map(({ key, label, data }) =>
                    !isArrayEmpty(selectedSurveyDetail?.[key]) ? (
                      <li key={key}>
                        <span>{t(`PARTICIPANT_FEEDBACK.${label}`)}</span>
                        <p>
                          {selectedSurveyDetail[key]?.map((item, index) => (
                            <b key={`user-${key}-${index}`}>
                              {transformArrayToObject(data)[item] || ""}
                            </b>
                          ))}
                        </p>
                      </li>
                    ) : (
                      ""
                    )
                  )}
                  {!isArrayEmpty(selectedSurveyDetail?.region) && (
                    <li>
                      <span>{t("PARTICIPANT_FEEDBACK.region")}</span>
                      <p>
                        {selectedSurveyDetail.region?.map((region, index) => (
                          <b key={`user-region-${index}`}>
                            {region?.name[language] || ""}
                          </b>
                        ))}
                      </p>
                    </li>
                  )}
                </ul>

                <h5>{t("PARTICIPANT_FEEDBACK.totalParticipant")}</h5>
                <p>{selectedSurveyDetail?.userCount ?? 0}</p>
                {surveyDetailsApi?.surveytype === "paid" && (
                  <>
                    <h5>{t("PARTICIPANT_FEEDBACK.pricePerParticipant")}</h5>
                    <p>
                      {`${getValueOrFallback(
                        selectedSurveyDetail?.rewardPerPerson
                      )} SAR`}
                    </p>
                    <h5>{t("PARTICIPANT_FEEDBACK.amount")}</h5>
                    <ul>
                      <li>
                        <span>{t("PARTICIPANT_FEEDBACK.totalAmount")}</span>
                        <p>
                          <b>
                            {(selectedSurveyDetail?.userCount || 0) *
                              (selectedSurveyDetail?.rewardPerPerson || 0)}{" "}
                            {t("COMMON.SAR")}
                          </b>
                        </p>
                      </li>
                    </ul>
                  </>
                )}
                <div className="button_wrap">
                  <Button className={"has_icon"}>
                    <IoShareSocialOutline />
                    {t("PARTICIPANT_FEEDBACK.share")}
                  </Button>
                  <Button
                    className={"light"}
                    onClick={() => setExtendSurveyDateModel(true)}
                  >
                    {t("PARTICIPANT_FEEDBACK.editExpiryDate")}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* <CustomModal
        show={feedbackSurvey}
        handleClose={() => setFeedbackSurvey(false)}
        className={"surveyFeedbackModal xl"}
      >
   
      </CustomModal> */}

      {/* Accept All Survey Model */}
      <CustomModal
        show={acceptAllSurveyModel}
        handleClose={closeModel}
        className={"acceptallsurveymodel"}
      >
        <AcceptAllSurvey handleClose={closeModel} surveyId={selectedSurveyId} />
      </CustomModal>

      {/* Extend Survey Date Model */}
      <CustomModal
        show={extendSurveyDateModel}
        handleClose={closeModel}
        className={"extendsurveymodel"}
      >
        <ExtendSurveyDate
          handleClose={closeModel}
          surveyId={selectedSurveyId}
          setSelectedSurveyDetail={setSelectedSurveyDetail}
          selectedSurveyDetail={selectedSurveyDetail}
        />
      </CustomModal>

      {feedbackSurvey && (
        <CustomModal
          show={feedbackSurvey}
          handleClose={closeModel}
          className={"surveyFeedbackModal xl"}
        >
          <SelectedParticipantFeedback
            handleClose={closeModel}
            surveyId={selectedSurveyId}
            selectedSurveyDetail={selectedSurveyDetail}
            selectedParticipantDetail={selectedParticipantDetail}
          />
        </CustomModal>
      )}
    </>
  );
};

export default FeedbackSurvey;
